import { buildAction } from 'store/actions/actionCreator'

import { CLOSE_STORE_DETAILS, OPEN_STORE_DETAILS } from './constants'

export const closeStoreDetails = buildAction(CLOSE_STORE_DETAILS)

export const openStoreDetails = buildAction(OPEN_STORE_DETAILS, 'payload')
